import React from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import PaidIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import down from "../../../../assets/down.svg";
import view from "../../../../assets/Wallet/view.png";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import StatusDropdown from "../../../../components/StatusDropdown";
import receipt from "../../../../assets/Wallet/receipt.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CustomButton from "../../../../components/CustomButton";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useTranslation } from "react-i18next";
import EditExpenseModal from "./EditModal.js"; // 👈 import it
import PayExpenseModal from "./PayExpenseModal.js";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils.js";

const DetailsDrawer = ({ open, onClose, data,onSuccess }) => {
  const { t } = useTranslation();
    const [editOpen, setEditOpen] = React.useState(false);
    const [payModalOpen, setPayModalOpen] = React.useState(false);

  console.log(data);
    const formatDateTime = (dateString) => {
  const formatted = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });
  return formatted === "—" ? "-" : formatted;
};
const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "";
  switch (currencyCode.toUpperCase()) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    default:
      return ""; // no text fallback if it's another currency
  }
};
 const isEditable =
    !["approved", "rejected"].includes((data?.status || "").toLowerCase());
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 550,
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
{t("salaryManagement.request")}          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        {/* Status & Date */}
        <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.status")}
            </CustomText>

              <Box sx={{ pointerEvents: "none" }}>
                    
                    <StatusDropdown currentStatus={data?.status} />
                    </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.date")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                              {formatDateTime(data?.created_at)}
            </CustomText>{" "}
          </Box>

              <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              mt: 1,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {t("salaryManagement.comments")}
            </CustomText>

            <Box
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "right",
              }}
            >
{data?.decision_note || "-"}            </Box>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 600,
              color: "#000000",
              textAlign: "left",
            }}
          >
{t("salaryManagement.requestDetails")}
        </CustomText>
          <img src={down} width={40} height={30} />
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.workerName")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
{data?.worker?.name}            </CustomText>{" "}
          </Box>



          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
{t("salaryManagement.amount")}          </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                    {/* {data?.amount} {data?.currency} */}
                     {getCurrencySymbol(data?.currency)}{""}{data?.amount}
            </CustomText>{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
{t("salaryManagement.dateOfExpense")}
           </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "left",
              }}
            >
                              {formatDateTime(data?.date_of_expense)}
            </CustomText>{" "}
          </Box>


          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 16,
                fontWeight: 400,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.description")}
            </CustomText>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                color: "#172B4D",
                textAlign: "right",
              }}
            >
              {data?.description}
            </CustomText>{" "}
          </Box>
        </Box>

        {/* Recipe Box (Optional) */}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
          sx={{ mt: 2 }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                fontWeight: 600,
                color: "#000000",
                textAlign: "left",
              }}
            >
              {t("salaryManagement.receipt")}
            </CustomText>
            <img src={down} width={40} height={30} />
          </Box>

          <Box>
            <img src={receipt} style={{ width: 30, height: 30 }} />
          </Box>
        </Box>

        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            py: 2,
            mt: 2,
          }}
        >
          <img         crossOrigin="anonymous"
 src={data?.receipt_url} style={{ width: "100%", height: "auto" }} />
        </Box>

        {/* Payment Information Section (if paid) */}
        {data?.status === "paid" && (
          <Box
            sx={{
              border: "1px solid #E4E6EF",
              borderRadius: 2,
              p: 2,
              mt: 2,
              backgroundColor: "#F8F9FA",
            }}
          >
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                fontWeight: 600,
                color: "#000000",
                mb: 2,
              }}
            >
              {t("reimbursementRequest.paymentInformation") ||
                "Payment Information"}
            </CustomText>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {/* Payment Date */}
              {data?.paid_at && (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                    }}
                  >
                    {t("reimbursementRequest.paymentDate") || "Payment Date"}:
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                    }}
                  >
                    {formatDateTime(data.paid_at)}
                  </CustomText>
                </Box>
              )}

              {/* Paid By */}
              {data?.paid_by_name && (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                    }}
                  >
                    {t("reimbursementRequest.paidBy") || "Paid By"}:
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                    }}
                  >
                    {data.paid_by_name}
                  </CustomText>
                </Box>
              )}

              {/* Payment Method */}
              {data?.payment_method && (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                    }}
                  >
                    {t("reimbursementRequest.paymentMethod") ||
                      "Payment Method"}:
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textTransform: "capitalize",
                    }}
                  >
                    {data.payment_method === "bank"
                      ? "Bank Transfer"
                      : data.payment_method === "transfer"
                      ? "Wire Transfer"
                      : data.payment_method === "cash"
                      ? "Cash"
                      : data.payment_method}
                  </CustomText>
                </Box>
              )}

              {/* Payment Comment */}
              {data?.paid_comment && (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                    }}
                  >
                    {t("reimbursementRequest.paymentComment") || "Comment"}:
                  </CustomText>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 15,
                      fontWeight: 400,
                      color: "#172B4D",
                      textAlign: "right",
                      maxWidth: "60%",
                    }}
                  >
                    {data.paid_comment}
                  </CustomText>
                </Box>
              )}

              {/* Payment Proof */}
              {data?.paid_proof_url && (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <CustomText
                    sx={{
                      ...textStyles.h1,
                      fontSize: 16,
                      fontWeight: 400,
                      color: "#5E5C5C",
                    }}
                  >
                    {t("reimbursementRequest.paymentProof") ||
                      "Payment Proof"}:
                  </CustomText>
                  <Box
                    component="a"
                    href={data.paid_proof_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      textDecoration: "none",
                      color: "#006EC2",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    <VisibilityIcon sx={{ fontSize: 16 }} />
                    <CustomText
                      sx={{
                        ...textStyles.h1,
                        fontSize: 14,
                        fontWeight: 400,
                        color: "#006EC2",
                      }}
                    >
                      {t("reimbursementRequest.viewProof") || "View Proof"}
                    </CustomText>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        )}

        <Box display="flex" gap={1} sx={{ mt: 2 }}>
              {isEditable && (
        <Box display="flex" gap={1} sx={{ mt: 2 }}>
          <CustomButton
            onClick={() => setEditOpen(true)}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EditIcon sx={{ fontSize: 16 }} />
                {t("salaryManagement.edit")}
              </Box>
            }
            sx={{
              backgroundColor: "#006EC2",
              color: "#fff",
              borderRadius: "4px",
              fontSize: 14,
              textTransform: "none",
              px: 2,
            }}
          />
        </Box>
      )}

      {/* Pay Button for Approved Expenses */}
      {data?.status === "approved" && (
        <Box display="flex" gap={1} sx={{ mt: 2 }}>
          <CustomButton
            onClick={() => setPayModalOpen(true)}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PaidIcon sx={{ fontSize: 16 }} />
                {t("reimbursementRequest.payExpense") || "Pay Expense"}
              </Box>
            }
            sx={{
              backgroundColor: "#006EC2",
              color: "#fff",
              borderRadius: "4px",
              fontSize: 14,
              textTransform: "none",
              px: 2,
            }}
          />
        </Box>
      )}

        </Box>
      </Box>
        <EditExpenseModal
        open={editOpen}
        // onClose={() => setEditOpen(false)}
        expense={data}
           onClose={(success) => {
          setEditOpen(false);
          if (success) {
            onClose();      // close drawer
            onSuccess?.();  // notify parent to refresh
          }
        }}
      />
      <PayExpenseModal
        open={payModalOpen}
        onClose={() => setPayModalOpen(false)}
        expense={data}
        onSuccess={() => {
          setPayModalOpen(false);
          onClose();      // close drawer
          onSuccess?.();  // notify parent to refresh
        }}
      />
    </Drawer>
  );
};

export default DetailsDrawer;